// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Teep","input":"styles_input__20cYV"};